import React from "react";
import { Star } from "lucide-react";
import { cn } from "../../lib/utils";

// 0–3 stars for a ladder rung. Filled = earned; the row reads at a glance on
// the journey map and the session summary.
const Stars = ({ n, className }) => (
  <span className={cn("inline-flex items-center gap-0.5", className)} aria-label={`${n} of 3 stars`}>
    {[0, 1, 2].map((i) => (
      <Star
        key={i}
        className={cn(
          "h-3.5 w-3.5",
          i < n ? "fill-amber-400 text-amber-400" : "text-muted-foreground/40"
        )}
      />
    ))}
  </span>
);

export default Stars;
